/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Property
 */
export interface Property {
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    ns?: string;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    classValue?: string;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    group?: string;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    remarks?: string;
}

/**
 * Check if a given object implements the Property interface.
 */
export function instanceOfProperty(value: object): value is Property {
    return true;
}

export function PropertyFromJSON(json: any): Property {
    return PropertyFromJSONTyped(json, false);
}

export function PropertyFromJSONTyped(json: any, ignoreDiscriminator: boolean): Property {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'value': json['value'] == null ? undefined : json['value'],
        'ns': json['ns'] == null ? undefined : json['ns'],
        'classValue': json['classValue'] == null ? undefined : json['classValue'],
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'group': json['group'] == null ? undefined : json['group'],
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
    };
}

export function PropertyToJSON(json: any): Property {
    return PropertyToJSONTyped(json, false);
}

export function PropertyToJSONTyped(value?: Property | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'value': value['value'],
        'ns': value['ns'],
        'classValue': value['classValue'],
        'uuid': value['uuid'],
        'group': value['group'],
        'remarks': value['remarks'],
    };
}

